import React, { useContext, useState, CSSProperties } from "react";
import { Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

interface TextProps {
  text: string;
  mb?: number;
  mt?: number;
  fontSize?: number;
  children?: any;
  style?: CSSProperties;
}
const DescreptionText = (props: TextProps) => {
  const { text, mt, mb, fontSize, children, style } = props;
  const theme = useTheme();

  return (
    <Typography component={"span"} variant={"body2"}>
      <Box
        style={style}
        fontSize={!!fontSize ? fontSize : theme.spacing(1.8)}
        // mt={mt}
        // mb={mb}
        fontWeight={"normal"}
        width={theme.spacing(80)}
        display={"flex"}
        flexDirection="row"
      >
        {text}&nbsp; {children}
      </Box>
    </Typography>
  );
};
export { DescreptionText };
